import {
  getProcessorOnboard,
  putProcessorOnboard,
  postProcessorOnboard,
  getOperation,
  fetchOperation,
  putOperation,
  putMaster,
  getMaster,
  fetchMaster,
  fetchFinance,
  delProcessorOffboard,
  delMaster,
} from "utils/api";

export const queryAgentMerchant = async (params) => {
  return await getOperation("/merchant/list", {
    sort: "createdDate,desc",
    ...params,
  });
};
/* --- Multiple Usage ---*/
export const updateMerchant = async (params) => {
  return await putOperation("/merchant/detail", {
    ...params,
  });
};

export const updateMerchantOtherInfo = async (params) => {
  return await putMaster("/merchant-detail-other-info", {
    ...params,
  });
};

export const updateMerchantOtherDetail = async (params) => {
  return await fetchFinance("/action", {
    ...params,
    action: "updateMerchant",
  });
};

/* --- Containter --- */
export const queryMerchantDetail = async (merchantId) => {
  return await getOperation("/merchant/detail", { merchantId: merchantId });
};

// Obsolete
// export const queryServiceIntegratorOptions = async () => {
//   return await getOperation("/terminal/service-integrator");
// };

export const queryDropdownOptions = async () => {
  return await getMaster("/dropdown-options");
};

export const queryMerchantOtherDetail = async (params) => {
  return await getMaster("/merchant-detail-other-info", {
    ...params,
  });
};

export const queryMerchantDocuments = async (merchantId) => {
  return await getMaster("/merchant/documents?merchantId=" + merchantId);
};

export const uploadMerchantDocument = async (params) => {
  return await fetchMaster("/merchant/documents", {
    ...params,
  });
};

export const deleteMerchantDocument = async (path) => {
  return await delMaster("/merchant/documents", { path });
};

export const requestMerchantDocumentUpload = async (params) => {
  return await fetchMaster("/merchant/documents/presign", {
    ...params,
  });
};

/* --- Employee Tab --- */
export const queryEmployeeList = async (params) => {
  return await getOperation("/employee/list", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const changePassword = async (params) => {
  return await fetchOperation("/admin/reset/password", {
    ...params,
  });
};

/* --- Processor & MDR Tab --- */
export const queryMerchantInfoAndGsi = async (merchantId) => {
  return await getProcessorOnboard(`/merchants/mdr-gsi/${merchantId}`);
};

export const queryMerchantPreference = async (params) => {
  return await getOperation("/merchant/preference", {
    ...params,
  });
};

export const queryAmexSponsoredMerchant = async (params) => {
  return await fetchOnboarding("/ecs/action", {
    ...params,
    action: "amex-sponsored-merchant-get-by-mid",
  });
};

export const saveAmexSponsoredMerchant = async (params) => {
  return await fetchOnboarding("/ecs/action", {
    ...params,
    action: "amex-sponsored-merchant",
    amexAction: "SAVE",
  });
};

export const createMerchantMdr = async (params) => {
  return await postProcessorOnboard("/merchants/mdr", {
    ...params,
  });
};

export const updateMerchantMdr = async (merchantMdrId, params) => {
  return await putProcessorOnboard(`/merchants/mdr/${merchantMdrId}`, {
    ...params,
  });
};

export const createGsi = async (params) => {
  return await postProcessorOnboard("/merchants/gsi", {
    ...params,
  });
};

export const updateGsi = async (gsiId, params) => {
  return await putProcessorOnboard(`/merchants/gsi/${gsiId}`, {
    ...params,
  });
};

export const postProcessorOnboardMerchant = async (
  merchantId,
  processor,
  onboardType,
) => {
  const body = {
    merchantId,
    processors: [processor],
    onboardType: onboardType || "MAS_ONBOARD",
  };
  return await postProcessorOnboard("/merchants", body);
};

export const deleteProcessorOnboardMerchant = async (merchantId, processor) => {
  const body = {
    merchantId,
    processor: processor,
  };
  return await delProcessorOffboard("/merchants", body);
};

/* --- Maintenance Record Tab --- */
export const queryTerminalList = async (params) => {
  return await getOperation("/terminal/list", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const updateTerminal = async (params) => {
  return await fetchOperation("/terminal/detail", {
    ...params,
  });
};

export const queryInstallationDate = async (params) => {
  return await getOperation("/terminal/installation", {
    ...params,
  });
};

export const queryMaintenanceParties = async () => {
  return await getOperation("/terminal/maintenance-party");
};

export const queryTerminalModelList = async () => {
  return await getOperation("/terminal/model-list");
};

export const checkTerminalSNDuplicated = async (params) => {
  return await fetchOperation("/terminal/check-sn-exist", { ...params });
};

/* --- SME Usage --- */
export const queryMerchantSMEUsage = async (merchantId) => {
  return await getOperation("/sme/monthly/list", {
    merchantId: merchantId,
    numberOfReports: 12,
  });
};
